import htmlToPdfmake from "html-to-pdfmake"
import { INFINITE } from "const"
import { MtProject } from "server/models"
import {
    LangType,
    RequirementList,
} from "client/store"
import {
    TableGroupedIds,
    TableNestedIds,
} from "client/components"
import * as Const from "client/components/pdfmake/template/const"

const OverviewPage = (
    requirementList: RequirementList,
    requirementNested: TableGroupedIds[],
    project: MtProject,
    lang: LangType,
) => {
    const stack: any[] = []

    const downwardArrow = (multiply: number) => ({
        width: 18 * multiply,
        image: "downwardArrow",
        fit: [10, 10],
        alignment: "right",
        margin: [0, 0, 3, 0],
    })

    const prepareNested = (nestedItems: readonly TableNestedIds[], nestedLevel: number) => {
        nestedItems.forEach(({ id, nestedIds }) => {
            const infinite = id === INFINITE
            const requirementId = Number(id)
            const requirement = requirementList[requirementId]

            const columns: any[] = []
            if (nestedLevel > 0) columns.push(downwardArrow(nestedLevel))

            if (infinite) {
                columns.push({
                    width: "*",
                    text: lang.infiniteRecursion,
                    lineHeight: 1.25,
                })
            } else if (requirement) {
                columns.push({
                    width: "*",
                    text: `${requirement.uniqueId}  -  ${requirement.name}`,
                    lineHeight: 1.25,
                })
            }

            stack.push({
                columns,
                margin: [0, 5, 0, 0],
            })

            prepareNested(nestedIds, nestedLevel + 1)
        })
    }

    requirementNested.forEach((group) => {
        const { nestedIds } = group
        prepareNested(nestedIds, 0)
    })

    return [
        {
            pageBreak: "before",
            style: Const.HEADER,
            text: project.name,
        },
        {
            style: Const.SUB_HEADER,
            text: `1.   ${lang.projectDescription}`,
            ...Const.TOC_HEADER_BASE,
        },
        {
            style: Const.PARAGRAPH,
            stack: htmlToPdfmake(project.description),
        },
        {
            style: Const.SUB_HEADER,
            text: `2.   ${lang.requirementsOverview}`,
            ...Const.TOC_HEADER_BASE,
        },
        {
            style: Const.PARAGRAPH,
            text: lang.requirementsReport,
            italics: true,
            margin: [0, 5, 0, 10],
        },
        {
            stack,
        },
    ] as any[]
}
export default OverviewPage
